import Color from "../color/Color";
import LightSource from "./LightSource";

export default class FlickeringLightSource extends LightSource {
    constructor() {
        super();

        /**
         * @constant
         * @type {Color}
         */
        this.flickerColor = new Color(1, 1, 1, 1);
    }

    /**
     * @override
     * @returns {Color}
     */
    getColor() {
        this.flickerColor.set(this.color);
        const s = -0.05 + (0.1 * Math.random());
        this.flickerColor.add(s, s, s, 0);
        return this.flickerColor;
    }

    /**
     * @override
     * @returns {number}
     */
    getTileRadius() {
        return this.radius + (Math.random() < 0.15 ? 1 : 0);
    }

}